import script from "./PostListCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostListCard.vue?vue&type=script&setup=true&lang=ts"

import "./PostListCard.vue?vue&type=style&index=0&id=1f243eca&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f243eca"]])

export default __exports__